module.exports = {"id":"199418","name":"Eric Bauthéac","rating":"73","photo":"./data/images/photos/2/199418.png","club":{"name":"Brisbane Roar","logo":"./data/images/clubs/BrisbaneRoar.png"},"positions":["AG","MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EricBautheac0.json
// module id = 1269
// module chunks = 0